import {Injectable} from '@angular/core';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata'
import {ChangeLog} from '../../features/history/models/historyLog';
import {ParentTableService} from '../table/parent-table.service';
import {exportable$} from '../table/decorators/exportable';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from '../table/mappers/odata-response-mapper';
import {HelperFunctions} from '../table/configuration/helper-functions';
import {SQDataConfiguration} from '../table/configuration/OData-configuration';

@Injectable()
export class HistoryService extends ParentTableService {
  private config: SQDataConfiguration;
  private odata: ODataEntitySetService<ChangeLog>;
  @exportable$ changelogs: any;

  constructor(private odataFactory: ODataServiceFactory) {
    super('HistoryService');
    this.config = new SQDataConfiguration();
    this.odata = this.odataFactory.entitySet<ChangeLog>('Overview(0)/ChangeLogs');
  }

  getData(pageIndex, count, sortModel, filterModel) {

    const orders = [];
    sortModel.forEach(x => orders.push(x.colId.replace(/\./g, '/') + ' ' + x.sort));


    let filter = '';
    for (const i in filterModel) {
      if (filter.length === 0) {
        filter += HelperFunctions.filterObject(i, filterModel[i]);
      } else {
        filter += ' AND ' + HelperFunctions.filterObject(i, filterModel[i]);
      }
    }

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });

    this.changelogs = query;
    return this.changelogs.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }
}
